import { useState } from 'react'
import { BUILDER_EXAMPLE } from '../../../data/platform'

export type AddOption = (typeof BUILDER_EXAMPLE.addOptions)[number]
export type DraftItem = { id: number; kind: AddOption }

/** Local-only state for the example workflow builder (nothing is saved). */
export function useWorkflowBuilder() {
  const stages = BUILDER_EXAMPLE.stages
  const [activeIndex, setActiveIndex] = useState(2)
  const [drafts, setDrafts] = useState<Record<number, DraftItem[]>>({})
  const [nextId, setNextId] = useState(1)
  const [announcement, setAnnouncement] = useState('')

  const activeStage = stages[activeIndex]
  const activeDrafts = drafts[activeIndex] ?? []

  const select = (index: number) => {
    if (index < 0 || index >= stages.length) return
    setActiveIndex(index)
  }

  const addDraft = (kind: AddOption) => {
    setDrafts((current) => ({ ...current, [activeIndex]: [...(current[activeIndex] ?? []), { id: nextId, kind }] }))
    setNextId((value) => value + 1)
    setAnnouncement(`${kind} placeholder added to ${activeStage.name}.`)
  }

  const removeDraft = (id: number) => {
    setDrafts((current) => ({ ...current, [activeIndex]: (current[activeIndex] ?? []).filter((item) => item.id !== id) }))
    setAnnouncement('Placeholder removed.')
  }

  const stageCount = (index: number) => {
    const stage = stages[index]
    return stage.agents.length + (drafts[index]?.length ?? 0)
  }

  return { stages, activeIndex, activeStage, activeDrafts, announcement, select, addDraft, removeDraft, stageCount }
}
